export const _arrayBufferToBase64 = (buffer) => {
    let binary = '';
    const bytes = new Uint8Array(buffer);
    const len = bytes.byteLength;
    for (let i = 0; i < len; i++) {
        binary += String.fromCharCode(bytes[i]);
    }
    return window.btoa(binary);
};

export const linebrk = (s, n) => {
    let ret = '';
    let i = 0;
    while (i + n < s.length) {
        ret += s.substring(i, i + n) + '\n';
        i += n;
    }
    return ret + s.substring(i, s.length);
};

const bto = () => {
    const tableStr =
        'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    const table = tableStr.split('');

    window.btoa = (bin) => {
        for (
            var i = 0, j = 0, len = bin.length / 3, base64 = [];
            i < len;
            ++i
        ) {
            let a = bin.charCodeAt(j++);
            let b = bin.charCodeAt(j++);
            let c = bin.charCodeAt(j++);
            if ((a | b | c) > 255){
                throw new Error('String contains an invalid character');
        }
            base64[base64.length] =
                table[a >> 2] +
                table[((a << 4) & 63) | (b >> 4)] +
                (isNaN(b) ? '=' : table[((b << 2) & 63) | (c >> 6)]) +
                (isNaN(b + c) ? '=' : table[c & 63]);
        }
        return base64.join('');
    };
};
export const hexToBase64 = (str) => {
    bto();
    return btoa(
        String.fromCharCode.apply(
            null,
            str
                .replace(/\r|\n/g, '')
                .replace(/([\da-fA-F]{2}) ?/g, '0x$1 ')
                .replace(/ +$/, '')
                .split(' ')
        )
    );
};


 // function to convert string to ArrayBuffer
 export const str2ab = (str) =>
 {
     var buf = new ArrayBuffer(str.length);
     var bufView = new Uint8Array(buf);
     for(var i = 0, strLen = str.length; i < strLen; i++)
         bufView[i] = str.charCodeAt(i);

     return buf;
 };


 export const rootCA = `-----BEGIN CERTIFICATE-----
    MIIGqjCCBVqgAwIBAgIUMDAwMDAwMDAwMDAwOTAwMDEwMTEwDQYJKoZIhvcNAQEL
    BQAwgZUxCzAJBgNVBAYTAk1YMQ0wCwYDVQQIDARELkYuMRkwFwYDVQQHDBBDaXVk
    YWQgZGUgTWV4aWNvMRgwFgYDVQQKDA9CYW5jbyBkZSBNZXhpY28xDDAKBgNVBAsM
    A0RTUDERMA8GA1UEAwwIQVJDIGJldGExITAfBgkqhkiG9w0BCQEWEmllc0BiYW54
    aWNvLm9yZy5teDAeFw0xODAyMjMyMTQ3MDNaFw0yMjAyMjMyMTQ3MDNaMIIBKzEP
    MA0GA1UEAwwGQUMgVUFUMS4wLAYDVQQKDCVTRVJWSUNJTyBERSBBRE1JTklTVFJB
    Q0lPTiBUUklCVVRBUklBMRowGAYDVQQLDBFTQVQtSUVTIEF1dGhvcml0eTEoMCYG
    CSqGSIb3DQEJARYZb3NjYXIubWFydGluZXpAc2F0LmdvYi5teDEdMBsGA1UECQwU
    M3JhIGNlcnJhZGEgZGUgY2FkaXoxDjAMBgNVBBEMBTA2MzcwMQswCQYDVQQGEwJN
    WDEZMBcGA1UECAwQQ0lVREFEIERFIE1FWElDTzERMA8GA1UEBwwIQ09ZT0FDQU4x
    ETAPBgNVBC0TCDIuNS40LjQ1MSUwIwYJKoZIhvcNAQkCExZyZXNwb25zYWJsZTog
    QUNETUEtU0FUMIICIjANBgkqhkiG9w0BAQEFAAOCAg8AMIICCgKCAgEA2w/1LfmQ
    DaKB8tnrtTeJC8IRubTm/07RBDrfzOZC6B1JjjtL8UGSOV3u4YAmJFfJ0WURvMVH
    XByhaDvRXIcJ6JvGz4RP4v6oRRYFqcr981p67iymfy7n9HCHV/0jOK9Zx7IS5xVs
    7nBBO+Gmqm92rNMAw7vort3lSNRrXbCeCe08khTs9pnJLdegXPm5kK52nN0MJ8MH
    1ba8uEPRtq8t47RBmq5Gopp+2CVc2nlBB5VlhS3HsjsQ9pwksoGzzDnP82m5diEJ
    vbQU3Eyo4kOih6D5aL8+t/6P+7VYneD/jwFjrhdaPLzsZ2Ksz1383twAmrTGyXjs
    hd1ZkDBwR9bfy9bM/Bq9f73fwxVAowqch3am/TJFDVTh203Rv5b3Iw78OVfu8tPl
    qdUFjI09UsJpwnnTKE0qW3vfInkgCvdntjmr7JPsfEgTvirWXy8hfX2F4w0rT08N
    bfeJJ1A2G/HQZwDet3dZjXSazxHBH/dn/RnjdH+4douQJkEKgVVCsygsL0m+YH2e
    SuUa9JKRgeEkg9zOngb1utWh87KZMEE3Hkksb/hisGiN6D9ezI7fjrAAkZJnMth6
    K/oowESYiRmQadTYrpRUIsXfNKVqXuazj81UVJBmPRgPj6pcgDyeK+OZr/Q63LIy
    yHGc2ZSWJz15eg4cf1/Ms4Q5x0ts7kXUU1sCAwEAAaOCAR8wggEbMIHVBgNVHSME
    gc0wgcqAFITCdzZIWsPOGE7hPQch+bKKQFEXoYGbpIGYMIGVMQswCQYDVQQGEwJN
    WDENMAsGA1UECAwERC5GLjEZMBcGA1UEBwwQQ2l1ZGFkIGRlIE1leGljbzEYMBYG
    A1UECgwPQmFuY28gZGUgTWV4aWNvMQwwCgYDVQQLDANEU1AxETAPBgNVBAMMCEFS
    QyBiZXRhMSEwHwYJKoZIhvcNAQkBFhJpZXNAYmFueGljby5vcmcubXiCFDAwMDAw
    MDAwMDAwMDkwMDAwMDAwMB0GA1UdDgQWBBQ7CURHy82lHj66gou82TftzQM32DAS
    BgNVHRMBAf8ECDAGAQH/AgEAMA4GA1UdDwEB/wQEAwIB9jANBgkqhkiG9w0BAQsF
    AAOCATkAn6nDNaACYPqA/p7aNq5mpP2ZMBGzGueQlVSQ3wWNDHdHFA20R0vZOf56
    qcLjjwHS7iZClgSB7RKJBKzJlLtW5YO5qw4Nc7nhylkvKTILCHOXbPzbJ8rv+9K/
    pr03p2PLXbwiLVVL6lKOsvbr+b5eNfQd5c85/sGhoZ6eDMNGOlW7rmJbJAj8mb6D
    7PJ7AjRJbcFnzZyGS9PCTHUE4AEYCfLInl0eHzz66ZUlCSqfJhq7FPiJGQwrKCym
    tHtcqxj9Y3MnuDe8dGaGHZmXr3lAMDNeToQYxs+Cgpn+ZKtla7FIui6lMlpoVBUH
    Wqq+p/MqyB3XaKUYe0EkC362xDUM9ntcgVIy/3km/iCgxeDuIQeHgGAG6QzDiqMa
    VN6QH+9mKh/Uo45J5giRHWdt55FlCLmdJuELXxHA
    -----END CERTIFICATE-----`
